import { DividendPerShareValues, DividendPerShareResult } from './types';

export function calculateDividendPerShare(values: DividendPerShareValues): DividendPerShareResult {
  const { totalDividend, sharesOutstanding } = values;
  if (totalDividend < 0) return { perShare: null, isValid: false, message: 'Total utdelning kan inte vara negativ' };
  if (sharesOutstanding <= 0) return { perShare: null, isValid: false, message: 'Antal aktier måste vara större än 0' };
  const perShare = totalDividend / sharesOutstanding;
  if (!isFinite(perShare)) return { perShare: null, isValid: false, message: 'Ogiltigt resultat' };
  return { perShare, isValid: true };
}


